import React from 'react';
import { CommentStart, CommentEnd } from '../comments';
import { useWidth } from '../width-context';
import { useConfig } from '../config-context';
import { WrapperInnerDiv } from './wrapper-inner-div';
export function WrapperInnerTable(props) {
    const { backgroundColor, backgroundUrl, children, padding } = props;
    const { width } = useWidth();
    const { renderComments } = useConfig();
    if (backgroundUrl || !renderComments) {
        return (React.createElement(WrapperInnerDiv, { backgroundUrl: backgroundUrl, padding: padding }, children));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentStart, null),
        React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { width: `${width}px` }, width: width, bgcolor: backgroundColor },
            React.createElement("tr", null,
                React.createElement("td", { style: {
                        lineHeight: '0px',
                        fontSize: '0px',
                        msoLineHeightRule: 'exactly',
                    } },
                    React.createElement(CommentEnd, null),
                    React.createElement(WrapperInnerDiv, { backgroundUrl: backgroundUrl, padding: padding }, children),
                    React.createElement(CommentStart, null)))),
        React.createElement(CommentEnd, null)));
}
//# sourceMappingURL=wrapper-inner-table.js.map